import react from 'react';
import moment from 'moment';
import styled from '@emotion/styled';

import { addComma } from 'constants/utils';
import { IStatistics } from 'types/salary';

const Wrap = styled.div`
  z-index: 2;
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 12px;
  background-color: #fff;
`;
const TableArea = styled.div`
  display: flex;
  margin-top: 30px;
  width: 100%;
`;
const Table = styled.table`
  min-width: 500px;
  border-collapse: collapse;

  thead {
    background-color: #fbfef6;
  }

  th {
    padding: 10px 0;
    text-align: center;
    font-weight: bold;
    border: 1px solid #ddd;

    span {
      font-size: 0.8rem;
    }
  }

  td {
    padding: 10px 20px;
    text-align: right;
    border: 1px solid #ddd;

    &:first-child {
      text-align: center;
    }
  }
`;

interface IResult {
  emps: string | number;
  payed: string | number;
  deduction: string | number;
  realPayed: string | number;
}

interface IProps {
  date: Date;
  data: IStatistics;
}

const PaystubStatistics = ({ date, data }: IProps) => {
  let PREV = moment(date).subtract(1, 'month').month() + 1; // 전월
  let THIS = moment(date).month() + 1; // 당월

  const AmountData = () => {
    let result: IResult = {
      emps: '0',
      payed: '0',
      deduction: '0',
      realPayed: '0',
    };

    result.emps = data.monthEmps - data.prevEmps;
    result.payed = data.monthPayed - data.prevPayed;
    result.deduction = data.monthDeductions - data.prevDeductions;
    result.realPayed = data.monthRealPayed - data.prevRealPayed;

    result.emps > 0 ? (result.emps = `+${result.emps}`) : (result.emps = `${result.emps}`);
    result.payed > 0
      ? (result.payed = `+${addComma(result.payed.toString())}`)
      : (result.payed = `${addComma(result.payed.toString())}`);
    result.deduction > 0
      ? (result.deduction = `+${addComma(result.deduction.toString())}`)
      : (result.deduction = `${addComma(result.deduction.toString())}`);
    result.realPayed > 0
      ? (result.realPayed = `+${addComma(result.realPayed.toString())}`)
      : (result.realPayed = `${addComma(result.realPayed.toString())}`);

    return result;
  };

  return (
    <Wrap>
      <TableArea>
        <Table>
          <thead>
            <tr>
              <th>구분</th>
              <th>
                당월<span>({THIS}월)</span>
              </th>
              <th>
                전월<span>({PREV}월)</span>
              </th>
              <th>증감</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>근로자수</td>
              <td>{addComma(data.monthEmps.toString())}</td>
              <td>{addComma(data.prevEmps.toString())}</td>
              <td>{AmountData().emps}</td>
            </tr>
            <tr>
              <td>총 지급액</td>
              <td>{addComma(data.monthPayed.toString())}</td>
              <td>{addComma(data.prevPayed.toString())}</td>
              <td>{AmountData().payed}</td>
            </tr>
            <tr>
              <td>총 공제액</td>
              <td>{addComma(data.monthDeductions.toString())}</td>
              <td>{addComma(data.prevDeductions.toString())}</td>
              <td>{AmountData().deduction}</td>
            </tr>
            <tr>
              <td>총 실지급액</td>
              <td>{addComma(data.monthRealPayed.toString())}</td>
              <td>{addComma(data.prevRealPayed.toString())}</td>
              <td>{AmountData().realPayed}</td>
            </tr>
          </tbody>
        </Table>
      </TableArea>
    </Wrap>
  );
};

export default PaystubStatistics;
